import React, { useState } from "react";
import styled from "styled-components";
import Mark from "../common/Mark";

interface MarkProps {
  mark?: "correct" | "incorrect";
}

const Styled = styled.div<MarkProps>`
  /* display: flex; */
  position: relative;
  padding: 1rem 1rem;
  border-top: solid 3px transparent;
  background-color: #f7f7f7;

  ${(props) => {
    if (props.mark === "correct") {
      return `
      background-color: #e4f3e4;
      border-top: solid 3px #9cb39c;
      `;
    }
    if (props.mark === "incorrect") {
      return `
      background-color: #f3e2e2;
      border-top: solid 3px #b32e2b;
      `;
    }
  }}

  .markup {
    position: absolute;
    top: -11px;
    right: -8px;
  }
`;

interface Props extends MarkProps {}

const OutcomeMark: React.FC<React.PropsWithChildren<MarkProps>> = (props) => {
  return (
    <Styled mark={props.mark}>
      {props.mark && <Mark type={props.mark} />}
      {props.children}
    </Styled>
  );
};

export default OutcomeMark;
